// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-layout .detect-panel {
  margin-top: 30px;
}

.settings-layout .detect-panel .header.column > div {
  overflow: hidden;
  line-height: inherit !important;
}

.settings-layout .detect-panel .header.column {
  max-width: 200px;
}

.settings-layout .detect-panel .detect-button {
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Settings/routes/Connectivity/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".settings-layout .detect-panel {\n  margin-top: 30px;\n}\n\n.settings-layout .detect-panel .header.column > div {\n  overflow: hidden;\n  line-height: inherit !important;\n}\n\n.settings-layout .detect-panel .header.column {\n  max-width: 200px;\n}\n\n.settings-layout .detect-panel .detect-button {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
